import { useEffect, useState } from 'react';
import { marketApi } from '@formosa/shared/api/market';
import { formatApiDateTime } from '@formosa/shared/utils/dateTime';

const DEFAULT_HISTORICAL_HOURS = 26;
const DEFAULT_POLL_MS = 15000;

function normalizeBars(rows) {
  if (Array.isArray(rows)) {
    return rows;
  }
  if (rows && typeof rows === 'object') {
    return Object.values(rows);
  }
  return [];
}

/**
 * 限時/行情頁 K 線：market 歷史 OHLCV + 定時刷新。
 */
export default function useMarketChart(symbolCode, options = {}) {
  const {
    historicalHours = DEFAULT_HISTORICAL_HOURS,
    enabled = true,
    pollMs = DEFAULT_POLL_MS,
  } = options;
  const [bars, setBars] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !symbolCode) {
      setBars([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      try {
        const endTime = new Date();
        const startTime = new Date(endTime.getTime() - historicalHours * 60 * 60 * 1000);
        let rows;
        try {
          rows = await marketApi.getHistoricalOhlcv(
            symbolCode,
            formatApiDateTime(startTime),
            formatApiDateTime(endTime)
          );
        } catch {
          rows = await marketApi.getLatestOhlcv(symbolCode, 80);
        }
        if (!cancelled) {
          setBars(normalizeBars(rows));
        }
      } catch {
        if (!cancelled) {
          setBars([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    const timer = setInterval(load, pollMs);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [symbolCode, enabled, historicalHours, pollMs]);

  return { bars, loading };
}
